import AppTablePage from "./AppTablePage"
import AppUpload from "./AppUpload/index.vue"
import EleFormItem from "./EleFormItem"
import eleTableColumn from "./elTableColumn"
import SvgIcon from "./SvgIcon"
import txtProcess from "./txtProcess"
import Empty from "./Empty"
import ElCardContent from "../cloud-clinic/components/ElCardContent.vue"
import CbNumber from "../cloud-clinic/components/CbNumber.vue"
import SimpleTable from "../cloud-clinic/components/SimpleTable.vue"
import CbTippy from "../cloud-clinic/components/CbTippy.vue"
import InputPanel from "../cloud-clinic/components/InputPanel.vue"
import CbTable from "@/components/common/CbTable.vue";
import CbConfirmDialog from "@/components/common/ConfirmDialog.vue";
import CbDialog from '@/components/common/CbDialog.vue';
import PositionOrg from '@/components/childcomponents/positionOrg';
import CbTree from '@/components/common/CbTree.vue'
export default {
    install(Vue) {
        // 1.全局组件
        Vue.component('FileUpload',AppUpload)
        Vue.component('TablePage', AppTablePage)
        Vue.component('EleFormItem',EleFormItem)
        Vue.component('eleTableColumn',eleTableColumn)
        Vue.component('SvgIcon',SvgIcon)
        Vue.component('txtProcess',txtProcess)
        Vue.component('empty', Empty)
        Vue.component('ElCardContent',ElCardContent)
        Vue.component('CbNumber',CbNumber)
        Vue.component('st',SimpleTable)
        Vue.component('cb-tippy',CbTippy)
        Vue.component('input-panel',InputPanel)
        Vue.component('CbTable',CbTable)
        Vue.component('CbConfirmDialog',CbConfirmDialog)
        Vue.component('CbDialog',CbDialog)
        Vue.component('PositionOrg',PositionOrg)
        Vue.component('CbTree',CbTree)
    }
}



// WEBPACK FOOTER //
// ./src/components/childcomponents/plugins.js